import { Button, CardContent, Dialog, DialogActions, DialogContent, DialogTitle, Grid, IconButton, Typography } from "@mui/material";

import { useEffect, useState } from "react";
import MyTable from "../../../components/MyTable";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../store";
import { approveCoupon, setCouponsToApproveERPReponse, setDeleteCouponRejected } from "../../../store/slices/userRequests";
import CloseIcon from '@mui/icons-material/Close';
import CheckIcon from '@mui/icons-material/Check';
import { DocumentsComponent } from "../../../components/DocumentsComponent";
import AttachFileIcon from '@mui/icons-material/AttachFile';

import "./index.css";
import { S10CouponsToMyChargeHistoryPartial, S10CouponsToMyChargePartial } from "../../../interfaces/s10Employees.interface";
import { CompanyEmployees } from "../../../interfaces/auth.interface";
import { COUPONS_TO_MY_CHARGE_HISTORY_ONE, COUPONS_TO_MY_CHARGE_HISTORY_THREE, COUPONS_TO_MY_CHARGE_HISTORY_TWO } from "../../../constants/signalRequestConsts";
import { setAproveCouponCloud, setRejectCouponCloud, setRevertCouponAppovation } from "../../../api/s10DocumentsApi";
import MySnackbar from "../../../components/MySnackbar";
import { CouponStatus } from "../../../enumns/Coupons";
import { formatDateToTimestamp } from "../../../utils/date";

type Employee = (S10CouponsToMyChargeHistoryPartial & CompanyEmployees);

interface TableAbsencesProps {
    rucEmpresa: string;
    requestId: (typeof COUPONS_TO_MY_CHARGE_HISTORY_ONE | typeof COUPONS_TO_MY_CHARGE_HISTORY_TWO |  typeof COUPONS_TO_MY_CHARGE_HISTORY_THREE)

    hiddenFilterOptions?: boolean;
    allowApproveOptions?: boolean;
    couponId: string;
    setStatus?: (value: string) => void;
    status?: string;
    page?: number;
    setPage?: (value: number) => void;
    pageSize?: number;
    setPageSize?: (value: number) => void;
    onUpdate?: () => void
}

const TableAbsences = ({
    rucEmpresa, 
    hiddenFilterOptions, 
    requestId, 
    allowApproveOptions, 
    couponId, 
    setStatus, 
    status,
    page,
    setPage,
    pageSize,
    setPageSize,
    onUpdate,
}: TableAbsencesProps) => {

    const dispatch = useDispatch<AppDispatch>();
    const {employeesHistory, couponToApproveERPResponse} = useSelector((state: RootState) => state.userRequests)[requestId];
    const [isLoading, setIsLoading] = useState<boolean>(false)
    const [groupId, setGroupId] = useState<string | null>(null);
    const [searchInputstring, setSearchInputstring] = useState<string>("")
    const [orderedEmployees, setOrderedEmployees] = useState<Employee[]>([])
    const [rejectCoupon, setRejectCoupon] = useState<any>()
    const [approveCouponData, setApproveCouponData] = useState<any>(null)
    const [rejectCouponData, setRejectCouponData] = useState<any>(null)


    useEffect(() => {
        // if (!employeesHistory?.length) return;
        setIsLoading(true)
        setOrderedEmployees([]);
        let employeesByRuc: Employee[] = [];
        for (let i = 0; i < employeesHistory.length; i++) {
            const employee = employeesHistory[i];
            const ruc: string = employee.RUCEmpresa || "sin ruc";
            if (rucEmpresa === 'all' || ruc === rucEmpresa) {
                employeesByRuc.push(employee);
            }
        }
        setOrderedEmployees(employeesByRuc);
        setIsLoading(false)
        
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [rucEmpresa, employeesHistory])

    useEffect(() => {
        if (couponToApproveERPResponse?.Success !== 1) {
            setApproveCouponData(null);
            setRejectCouponData(null)
            return;
        }
        setAproveCouponCloud()
            .then(s => {
                console.log(s);
                setApproveCouponData(null);
                setRejectCouponData(null)
                if(s.Type === 0 && onUpdate) {
                    onUpdate()
                }
            });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [couponToApproveERPResponse]);


    const handleAproveCoupon = async (couponRequestData: S10CouponsToMyChargePartial & CompanyEmployees) => {
        console.log(approveCouponData)
        dispatch(approveCoupon(couponRequestData, requestId));
    }

    const handleRejectCoupon = async (couponRequestData: S10CouponsToMyChargePartial & CompanyEmployees) => {
        console.log(couponRequestData);
        const result = await setRejectCouponCloud(couponRequestData);
        console.log(result)
        setRejectCouponData(null);
        setRejectCoupon({
            Message: result?.Message || result?.Response || "Ocurrió un error.",
            Type: result?.Type,
        });
        if (result?.Type === 0) {
            dispatch(setDeleteCouponRejected({requestId, CouponCode: couponRequestData.CouponCode}))
            if (onUpdate) onUpdate()
        }
    }

    const tableHeadRows = [
        {
            label: "Colaborador",
            rowKeyName: "Descripcion",
        },{
            label: "Cupón",
            rowKeyName: "CouponName",
        },{
            label: "Fecha Solicitud",
            rowKeyName: "RequestDate",
        },{
            label: "Fec. inicio",
            rowKeyName: "RangeStart",
        },{
            label: "Fec. fin",
            rowKeyName: "RangeEnd",
        },{
            label: "Cantidad",
            rowKeyName: "RangeCountString",
        }, {
            label: "",
            rowKeyName: "actions",
            customValue: (headRow: any, row: any) => {
                if (!row.HasAttachment) {
                    return <></>
                }
                return (                                  
                    <Grid
                        container
                        padding={0}
                        spacing={0}
                        // marginTop="1rem"
                        direction="row"
                    >
                        <IconButton
                            aria-label="ver adjuntos"
                            onClick={() =>{
                                setGroupId(row.FilesGroup)
                            }}
                            style={{
                                // minWidth: "2rem",
                                // minHeight: "2rem",
                                padding: "0 !impoertant",

                                lineHeight: "1.25rem", 
                            }}
                        >
                            <AttachFileIcon color="primary" />
                        </IconButton>
                    </Grid>
                )
            },
        }, {
            label: "",
            rowKeyName: "actions",
            customValue: (headRow: any, row: any) => {
                return <AppovalOptions row={row} />
            },
        }
    ]

    const handleRevertCoupon = async(row: any) => {
        console.log(row)
        const result = await setRevertCouponAppovation(row.Id);
        console.log(result)
        setRejectCoupon({
            Message: result?.Message || result?.Response || "Ocurrió un error.",
            Type: result?.Type,
        })
    }

    const AppovalOptions = ({row}: {row: any}) => {
        if(!allowApproveOptions) return <></>;
        return (
            <>
                <Grid 
                    container 
                    item
                    xs={11}
                    direction="row"
                    justifyContent="end"
                    sx={{
                        alignItems: "center",
                    }}
                >
                    {row.State !== 1 && <Grid item>
                        <Button
                            color="success"
                            variant="outlined"
                            style={{
                                padding: ".1rem",
                                lineHeight: "normal",
                            }}
                            disabled={!row.ApprovalCode}
                            onClick={() =>setApproveCouponData(row)}
                        >
                            Aprobar
                        </Button>
                    </Grid>}
                    {row.State !== 1 && <Grid item>
                        <Button
                            color="error"
                            variant="outlined"
                            style={{
                                padding: ".1rem",
                                lineHeight: "normal",
                                marginLeft: ".5rem"
                            }}
                            disabled={!row.ApprovalCode}
                            onClick={() =>setRejectCouponData(row)}
                        >
                            Rechazar
                        </Button>
                    </Grid>}
                    {row.State === 1 && <Grid item>
                        <Button
                            color="error"
                            variant="outlined"
                            style={{
                                padding: ".1rem",
                                lineHeight: "normal",
                                marginLeft: ".5rem"
                            }}
                            // disabled={!row.ApprovalCode}
                            onClick={() => handleRevertCoupon(row)}
                        >
                            Volver a pendiente
                        </Button>
                    </Grid>}
                </Grid>
            </>


        )

    }

    const getStatusOptions = (): any[] => {
        if (requestId === COUPONS_TO_MY_CHARGE_HISTORY_TWO) {
            return [
            {label: "Aprobados y rechazados", value: `${CouponStatus.Todos}`},
            {label: "Aprobados", value: `${CouponStatus.Aprobados}`},
            {label: "Rechazados", value: `${CouponStatus.Rechazados}`},
            ]
        }
        if (requestId === COUPONS_TO_MY_CHARGE_HISTORY_ONE) {
            return [
                {label: "Pendientes", value: `${CouponStatus.Pendientes}`},
            ]
        }
        return [
            {label: "Todos", value: `${CouponStatus.Todos}`},
            {label: "Pendientes", value: `${CouponStatus.Pendientes}`},
            {label: "Aprobados", value: `${CouponStatus.Aprobados}`},
            {label: "Rechazados", value: `${CouponStatus.Rechazados}`},
            {label: "Utilizados", value: `${CouponStatus.Utilizados}`},
        ]
    }

    return (
    <Grid item width="100%" marginTop="1.5rem" minHeight="100%">

        <MyTable
            key="tab-0"
            searchInputString={searchInputstring}
            onChangeSearchInputString={setSearchInputstring}
            onChangeItemsPerPage={(quantity) => {
                if (setPageSize) setPageSize(quantity)
            }}
            onChangePageNumber={(page) => {
                if (setPage) setPage(page);
            }}
            tableHeadRows={tableHeadRows}
            tableRows={orderedEmployees}
            loading={isLoading}
            hiddenBottomPaginator={true} 
            hiddenFilterOptions={hiddenFilterOptions}
            selectControlProps={{
                label: "Estado",
                onChange: (satus) => {
                    if (setPage) setPage(1);
                    if(setStatus) setStatus(satus);
                },
                options: getStatusOptions(),
                value: status,
            }}
            cardComponent={{
                imageData: {
                    descriptionRowName: "Descripcion",
                },
                className:  (row) => row.State === CouponStatus.Aprobados
                                        ? "coupon-appoved" 
                                        : row.State === CouponStatus.Rechazados
                                            ? "coupon-rejected"
                                            : "coupon-pending",
                cardContent: (row) => {
                    return (
                        <CardContent style={{padding: "0 1rem 1rem 1rem"}}>
                            <Typography variant="body1" style={{marginTop: ".2rem"}}>
                                Empresa: {" "}
                                <Typography variant="body2" component="span">
                                    {row.DescripcionEmpresa}
                                </Typography>
                            </Typography>
                            <Typography variant="body1" style={{marginTop: ".2rem"}}>
                                Tipo: {" "}
                                <Typography variant="body2" component="span">
                                    {row.CouponName}
                                </Typography>
                            </Typography>
                            <Typography variant="body1" style={{marginTop: ".2rem"}}>
                                Estado: {" "}
                                <Typography variant="body2" component="span">
                                    {row.State === CouponStatus.Aprobados
                                            ? "Aprobado"
                                            : row.State === CouponStatus.Utilizados 
                                                ? "Utilizado"
                                                : row.State === CouponStatus.Pendientes
                                                    ? "Pendiente"
                                                    : "Rechazado"
                                    }
                                </Typography>
                            </Typography>
                            <Typography variant="body1" style={{marginTop: ".2rem"}}>
                                Rango: {" "}
                                <Typography variant="body2" component="span">
                                    {row.RangeDateInfo}
                                </Typography>
                            </Typography>
                            <Typography variant="body1" style={{marginTop: ".2rem"}}>
                                Solicitado el: {" "}
                                <Typography variant="body2" component="span">
                                    {`${formatDateToTimestamp(row.RequestDate || row.CreationDate || row.Date)}`}
                                </Typography>
                            </Typography>                                         
                            <Grid
                                container
                                padding={0}
                                spacing={0}
                                marginTop="1rem"
                                direction="row"
                            >
                                {row.HasAttachment && <Grid item xs={1}>
                                    <IconButton
                                        aria-label="ver adjuntos"
                                        onClick={() =>{
                                            setGroupId(row.FilesGroup)
                                        }}
                                        style={{
                                            minWidth: "2rem",
                                            minHeight: "2rem",
                                            padding: ".25rem",

                                            lineHeight: "1.25rem", 
                                        }}
                                    >
                                        <AttachFileIcon color="primary" />
                                    </IconButton>
                                </Grid>}
                                

                                <AppovalOptions row={row}/>
                            </Grid>
                        </CardContent>
                    );
                },
                numberOfCards: 1,
                changeViewOptionHidden: true,
            }}
            tableOptionsBar={{
                useDrawer: true,
            }}
        />
        
        {groupId !== null && <Dialog
            key={groupId}
            maxWidth="md"
            
            open={groupId !== null}
            aria-labelledby="responsive-dialog-title"
            style={{width: "100%"}}
            PaperProps={{
                style: {
                width: '80%',
                }
            }}
            fullWidth
        
        >
            <DialogTitle 
                id="responsive-dialog-title" 
                style={{padding: "0", margin: "2rem 0 1rem 0", textAlign: "center"}} 
                variant="h5"
            >
                Documentos
            </DialogTitle>
            <DialogContent style={{width: "100%", textAlign: "center"}}>
                <DocumentsComponent groupId={groupId} allowToDeleteFiles={false} allowToAddFiles={false} />
            </DialogContent>
            <DialogActions>
                <Grid container margin={"0.5rem 1.5rem 2rem 1.5rem"}>
                    <Grid item xs={12} textAlign={"right"}>
                        <Button 
                            variant="outlined" 
                            style={{width: "8rem", margin: ".5rem",}}
                            startIcon={<CloseIcon style={{height: "1rem"}} />}
                            onClick={() => setGroupId(null)}
                        >
                            Cerrar
                        </Button>
                    </Grid>
                </Grid>
            </DialogActions>
        </Dialog>}
    
        {(approveCouponData || rejectCouponData) && <Dialog
            open={true}
            aria-labelledby="responsive-dialog-title"
            style={{width: "100%"}}
        >
            <DialogTitle
                id="responsive-dialog-title" 
                style={{padding: "0", textAlign: "center", marginTop: "1.5rem"}} 
                variant="h5"
            >
                {approveCouponData ? "Aprobar" : "Rechazar"} cupón
            </DialogTitle>
            <DialogContent style={{width: "100%", textAlign: "center"}}>
            </DialogContent>
                <DialogTitle 
                    id="responsive-dialog-title" 
                    style={{padding: "0", textAlign: "center"}} 
                    variant="body1"
                >
                    ¿Seguro de {approveCouponData
                                ? "aprobar"
                                : "rechazar"
                            } el cupón?
                </DialogTitle>
            <DialogActions>
                <Grid container >
                    <Grid item xs={6}>
                        <Button 
                            variant="outlined" 
                            style={{width: "8rem", margin: ".5rem",}}
                            startIcon={<CloseIcon style={{height: "1rem"}} />}
                            onClick={() => {
                                setApproveCouponData(null);
                                setRejectCouponData(null);
                            }}
                        >
                            Cancelar
                        </Button>
                    </Grid>
                    <Grid item xs={6} textAlign={"right"}>
                        <Button 
                            variant="contained"
                            color={approveCouponData
                                ? "primary"
                                : "error"
                            }
                            style={{width: "8rem", margin: ".5rem",}}
                            startIcon={<CheckIcon style={{height: "1rem"}} />}
                            onClick={approveCouponData
                                ? () => handleAproveCoupon(approveCouponData)
                                : () => handleRejectCoupon(rejectCouponData)
                            }
                        >
                            {approveCouponData
                                ? "Aprobar"
                                : "Rechazar"
                            }
                        </Button>
                    </Grid>
                </Grid>
            </DialogActions>
        </Dialog>}


        {couponToApproveERPResponse && <MySnackbar
            msg={couponToApproveERPResponse?.Response}
            severity={couponToApproveERPResponse.Success ? "success" : "error"}
            open={!!couponToApproveERPResponse}
            onClose={() => {
                dispatch(setCouponsToApproveERPReponse({data: null, requestId}))
            }}
        />}
        {rejectCoupon && <MySnackbar
            msg={rejectCoupon.Message}
            severity={rejectCoupon.Type === 0 ? "success" : "error"}
            open={!!rejectCoupon}
            onClose={() => {
                setRejectCoupon(undefined)
            }}
        />}



    </Grid>)
}

export default TableAbsences;